import EventBase from "@/app/events/event-base";
import router, { Routes } from "@/router";
import {ContextAware, DetailContext} from "@/app/contexts/detail.context";
import { Vue } from "vue-property-decorator";

export default class EditDossierEvent extends EventBase {
  async getCallBack(context: ContextAware, payload: any, rawPayload: any): Promise<any> {
    const dossierId = payload?.dossierId || context.getData().dossierId;
    router.push({
      name: Routes.EditDossierV2,
      params: { id: dossierId },
    });
  }
}
